import { Page } from 'components/Page';
import { PageHeader } from 'layouts/Generic/page-header';
import * as React from 'react';
import { ReactComponent as DownloadIcon } from 'assets/icons/download-icon.svg';
import { useRegion } from 'common/hooks/region';
import { useShowSmartPerDiem } from './hooks';
import { DateRange, SmartPerDiem, SpecificDate } from './views';

import { usePerDiemParams } from './params';
import { PerDiemArchiveMode } from './types';
import { ModeRadios } from './components/mode-radios';
import { TutorialCards } from './components/TutorialCards';

const PER_DIEM_GUIDE_LINK = 'https://docsend.com/view/icsmsuxa5n2be5xr';

export const PerDiemArchive: React.FC = () => {
  const { searchParams } = usePerDiemParams(false);
  const smartPerDiem = useShowSmartPerDiem();
  const { mode } = searchParams;
  const region = useRegion();

  let content = null;
  switch (searchParams.mode as PerDiemArchiveMode) {
    case PerDiemArchiveMode.DateRange:
      content = <DateRange />;
      break;
    case PerDiemArchiveMode.SmartPerDiem:
      content = smartPerDiem ? <SmartPerDiem /> : <DateRange />;
      break;
    case PerDiemArchiveMode.SpecificDate:
    default:
      content = <SpecificDate />;
      break;
  }

  return (
    // This key facilitates the resetting of the page when the region changes
    <Page className="flex flex-col space-y-2" key={region.code}>
      <div className="px-16 pt-8 space-y-2">
        <TutorialCards />
        <PageHeader
          title="Per Diem Disputes"
          description="Browse historical empty receiving & appointment screenshots to Fight Per Diem historical empty receiving"
          headerRight={
            <a href={PER_DIEM_GUIDE_LINK} target="_blank" rel="noreferrer">
              <button
                type="button"
                className="text-blue-900 hover:bg-blue-100 px-2 py-1 border gap-1 border-blue-900 shadow-sm rounded font-medium text-xs flex items-center"
              >
                <DownloadIcon className="w-4" />
                Download the PDF guide
              </button>
            </a>
          }
        />
        {/* SmartPerDiem handles its own mode radios */}
        {mode !== PerDiemArchiveMode.SmartPerDiem && <ModeRadios />}
      </div>
      {content}
    </Page>
  );
};
